import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface GpsTripsStats {
  today: number;
  yesterday: number;
  thisWeek: number;
  thisMonth: number;
  percentChange: number;
  totalDistanceKm: number;
}

export function useGpsTripsStats(companyId?: string, period: 'today' | 'week' | 'month' = 'today') {
  return useQuery({
    queryKey: ['gps-trips-stats', companyId, period],
    queryFn: async (): Promise<GpsTripsStats> => {
      if (!companyId) {
        return {
          today: 0,
          yesterday: 0,
          thisWeek: 0,
          thisMonth: 0,
          percentChange: 0,
          totalDistanceKm: 0,
        };
      }

      const now = new Date();
      
      // Today
      const todayStart = new Date(now);
      todayStart.setHours(0, 0, 0, 0);

      // Yesterday
      const yesterdayStart = new Date(todayStart);
      yesterdayStart.setDate(yesterdayStart.getDate() - 1);

      // This week
      const weekStart = new Date(now);
      weekStart.setDate(weekStart.getDate() - 7);

      // This month
      const monthStart = new Date(now);
      monthStart.setMonth(monthStart.getMonth() - 1);

      // For now, return mock data (will be replaced with real RPCs)
      const todayTrips: any[] = [];
      const yesterdayTrips: any[] = [];
      const weekTrips: any[] = [];
      const monthTrips: any[] = [];

      const today = 0;
      const yesterday = 0;
      const percentChange = 0;

      const totalDistanceKm = 0;

      return {
        today,
        yesterday,
        thisWeek: 0,
        thisMonth: 0,
        percentChange: Math.round(percentChange),
        totalDistanceKm: Math.round(totalDistanceKm),
      };
    },
    enabled: !!companyId,
    refetchInterval: 60000, // Refresh every minute
    staleTime: 45000,
  });
}
